module.exports = __webpack_public_path__ + "img/bg3@3x.58bf762e.png";